module.exports = __webpack_public_path__ + "img/qanda01.328b02a.webp";